/**
 * 城市 → 园区场景配图（与 data-pipeline/tools/gen-city-covers.mjs 的文件名保持一致）
 * 图片由城市地域特征生成，同城园区共用；未覆盖城市回落到通用图。
 */
const FALLBACK = 'https://bce.bdstatic.com/file-upload-skill/opc/images/park-hero-scene.webp';

const CITY_FILE: Record<string, string> = {
    苏州: 'suzhou', 武汉: 'wuhan', 杭州: 'hangzhou', 北京: 'beijing', 成都: 'chengdu',
    南京: 'nanjing', 扬州: 'yangzhou', 深圳: 'shenzhen', 济南: 'jinan', 南宁: 'nanning',
    青岛: 'qingdao', 无锡: 'wuxi', 上海: 'shanghai', 佛山: 'foshan', 广州: 'guangzhou',
    梅州: 'meizhou', 合肥: 'hefei', 宁波: 'ningbo', 常州: 'changzhou', 长沙: 'changsha',
    重庆: 'chongqing', 沈阳: 'shenyang', 海口: 'haikou', 保定: 'baoding', 温州: 'wenzhou',
    宿迁: 'suqian', 厦门: 'xiamen', 南通: 'nantong', 漳州: 'zhangzhou', 郑州: 'zhengzhou',
    连云港: 'lianyungang', 珠海: 'zhuhai', 昆山: 'kunshan', 中山: 'zhongshan', 福州: 'fuzhou',
    江门: 'jiangmen', 东莞: 'dongguan', 衢州: 'quzhou', 济宁: 'jining', 哈尔滨: 'harbin',
    徐州: 'xuzhou', 大同: 'datong', 陵水: 'lingshui', 银川: 'yinchuan', 玉林: 'yulin',
    绵阳: 'mianyang', 石家庄: 'shijiazhuang', 澄迈: 'chengmai', 海宁: 'haining', 日照: 'rizhao',
    廊坊: 'langfang', 泉州: 'quanzhou', 河源: 'heyuan', 清远: 'qingyuan', 淮安: 'huaian',
    襄阳: 'xiangyang', 西安: 'xian', 池州: 'chizhou', 三河: 'sanhe', 盐城: 'yancheng',
    哈密: 'hami', 南充: 'nanchong', 乌鲁木齐: 'urumqi', 天津: 'tianjin', 张家港: 'zhangjiagang',
    如皋: 'rugao', 常熟: 'changshu', 大连: 'dalian', 淮北: 'huaibei', 海门: 'haimen',
    黄山: 'huangshan', 威海: 'weihai', 马鞍山: 'maanshan', 滁州: 'chuzhou', 大理: 'dali',
    枣庄: 'zaozhuang', 柳州: 'liuzhou', 海安: 'haian', 湖州: 'huzhou',
};

/**
 * 返回该城市的配图 URL；无对应图时返回通用图
 * @param size card = 480w 小图（列表可能同屏出现数十城市），hero = 1280w 大图
 */
export function cityCover(city: string, size: 'card' | 'hero' = 'hero'): string {
    const file = CITY_FILE[city];
    if (!file) return FALLBACK;
    return `https://bce.bdstatic.com/file-upload-skill/opc/images/cities/${file}${size === 'card' ? '-sm' : ''}.jpg`;
}
